import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PortalJobScheduler from
    '../job-scheduling/portal-job-scheduler.jsx';
import GoogleMapReact from 'google-map-react';
import { Animate } from 'react-simple-animate';

const DriverMarker = ({text, data}) => (
  <div id={'driver-marker-for-driver-'+data.driver.id}
  style={{
    position: 'relative', color: '#fff',
    background: '#00f', textAlign: 'center',
    height: 16, width: 16, borderRadius: '1rem',
    content: data.driver.id, lineHeight: "16px"
  }}
  className="dashboard-map-driver-marker dashboard-map-marker"
  >
  <div onClick={(e) => {
    $('#driver-marker-for-driver-'+data.driver.id+
    ' .dashboard-map-popup').slideDown();
  }}>{data.driver.id}</div>

  <div className="dashboard-map-popup text-left">
    <button
      onClick={(e) => {
        $('#driver-marker-for-driver-' + data.driver.id +
        ' .dashboard-map-popup').fadeOut();
      }}
      className="dashboard-map-popup-close-button btn btn-sm btn-dark"> X </button>
    <div className="row">
      <div className="col-md-4">
        <img src={"/user-images/"+data.id} style={{
          maxWidth: '100%',
          height: 'auto'}} />
      </div>
      <div className="col-md-8">
      <h3 className="text-left">{data.first_name} {data.last_name}</h3>
      <h4>(Driver #{data.driver.id})</h4>
      <h5>From {data.company.short_name}</h5>

      </div>
    </div>
<br />
    <div className="row">
      <div className="col-md-6">
      <h5>Controls:</h5>
      <p>
        <a href={"/jobs/drivers/"+data.driver.id}
           className="btn btn-sm btn-primary">
          Driver's Jobs
        </a>
      </p>
      <p>
        <strong>Current Job:</strong>
      </p>
      <p>
        <strong>Next dropoff due @</strong>
      </p>
      </div>
      <div className="col-md-6">
        <strong><i className="fa fa-phone"></i></strong> {data.driver.contact_number}<br />
        <br />
        <strong><i className="fa fa-envelope"></i></strong> {data.email}<br />
        <br />
        <strong><i className="fa fa-home"></i></strong> {data.driver.home_address.town_city
        } {data.driver.home_address.county_area}<br />
      </div>
    </div>
  </div>
</div>
);

const BoxJob = ({data}) => (
  <div className="box-job-container">
    <button className="btn btn-sm btn-dark"
    onMouseOver={() => {
      $('.dashboard-map-marker').not([
        document.getElementById(data.id+'-pickup'),
        document.getElementById(data.id+'-dropoff')
      ]).hide();
    $('.dashboard-map-driver-marker').fadeIn();
      $('#'+data.id+'-pickup').fadeIn();
      $('#'+data.id+'-dropoff').fadeIn();
    }}
    onMouseOut={() => {
      $('.dashboard-map-marker').fadeIn();
    }}
    onDoubleClick={() => {
      location.assign('/jobs/view/'+data.id);
    }}
    onContextMenu={(e) => {
      e.preventDefault();
      $('#'+data.id+'-pickup .dashboard-map-popup').slideDown();
      $('#'+data.id+'-dropoff .dashboard-map-popup').slideDown();
    }}
    >
    Job #{data.id} - {data.pickup_address.town_city} to {data.dropoff_address.town_city}
    </button>
  </div>
)

const BoxDriver = ({data}) => (
  <div className="box-driver-container">
    <button className="btn btn-sm btn-dark"
    onMouseOver={() => {
      $('.dashboard-map-driver-marker').not([
        document.getElementById('driver-marker-for-driver-'+data.driver.id),
      ]).hide();
      $('#driver-marker-for-driver-'+data.driver.id).fadeIn();
    }}
  onMouseOut={() => {
    $('.dashboard-map-marker').fadeIn();
  }}
    onDoubleClick={() => {
      location.assign('/drivers/view/'+data.driver.id);
    }}
    onContextMenu={(e) => {
      e.preventDefault();
      $('#driver-marker-for-driver-'+data.driver.id+
      ' .dashboard-map-popup').slideDown();

    }}
    >
    Driver #{data.driver.id} - {data.first_name} {data.last_name}
    </button>
  </div>
)


const JobPickupLocation = ({ text, data }) => (
  <div id={data.id+'-pickup'}
  style={{
    position: 'relative', color: data.pickup_text_colour,
    background: data.pickup_colour, textAlign: 'center',
    height: 16, width: 16, borderRadius: '0',
    content: "P", lineHeight: "16px"
  }}
  className="dashboard-map-pickup-location dashboard-map-marker"
  >
  <div onClick={(e) => {

    $('#'+data.id+'-pickup .dashboard-map-popup').slideDown();
  }}>P</div>

  <div className="dashboard-map-popup">
  <button onClick={(e) => {

    $('#'+data.id+'-pickup .dashboard-map-popup').fadeOut();
  }} className="dashboard-map-popup-close-button btn btn-sm btn-dark"> X </button>

  <h4>
  Pickup Point for <a href={"/jobs/view/"+data.id}
                      className="btn btn-primary btn-sm">Job #{data.id}</a>
  </h4>

  <div className="text-left">
  <strong>Company:</strong> {data.company.name}<br />
  <strong>Customer:</strong> {data.customer.name}<br />
  </div>
  <br />

  <div className="text-left">
  <div className="row">
  <div className="col-md-5">
  {(data.driver_id != null) ?
    <p>
    <strong>Driver:</strong><br />
    <a href={"/drivers/view/"+data.driver.id}>
    {data.driver.user.first_name} {data.driver.user.last_name}
    <img src={"/user-images/"+data.driver.user.id} height="100" width="100" />
    </a>
    </p>

    : <p className="alert alert-danger alert-in-map"
         onClick={(e) => handleJobScheduling(data)}>
    <i className="fa fa-exclamation"></i> No Driver.<br />
    <i className="fa fa-exclamation"></i> Not Scheduled.</p>
  }
  </div>
  <div className="col-md-7">
  <strong>Scheduled for Pickup:</strong><br />
  {data.pickup_preposition}&nbsp;&nbsp;
  {data.pickup_day} / {data.pickup_month} / {data.pickup_year}<br />
  @ {data.pickup_time}<br />
  <br />
  <strong>Scheduled for Dropoff:</strong><br />
  {data.dropoff_preposition}&nbsp;&nbsp;
  {data.dropoff_day} / {data.dropoff_month} / {data.dropoff_year}<br />
  @ {data.dropoff_time}<br />
  <br />
  <strong>Vehicle:</strong><br />
  {data?.vehicle?.type}<br />
  {data?.vehicle?.colour} {data?.vehicle?.make} {data?.vehicle?.model}<br />
  <em>reg:</em> {data?.vehicle?.registration_number}
  </div>
  </div>
  </div>


  <div className="text-left">
  <strong>Pickup Address:</strong>
  <p>
  {data.pickup_address.house_number_or_name}&nbsp;
  {data.pickup_address.address_line_1}&nbsp;
  {data.pickup_address.address_line_2}&nbsp;
  {data.pickup_address.address_line_3}&nbsp;
  {data.pickup_address.town_city}&nbsp;
  {data.pickup_address.county_area}&nbsp;
  {data.pickup_address.country}<br />
  {data.pickup_address.postcode}
  </p>
  <strong>Dropoff Address:</strong>
    <p>
    {data.dropoff_address.house_number_or_name}&nbsp;
    {data.dropoff_address.address_line_1}&nbsp;
    {data.dropoff_address.address_line_2}&nbsp;
    {data.dropoff_address.address_line_3}&nbsp;
    {data.dropoff_address.town_city}&nbsp;
    {data.dropoff_address.county_area}&nbsp;
    {data.dropoff_address.country}<br />
    {data.dropoff_address.postcode}
    </p>
  </div>
  </div>
  </div>
);

function handleJobScheduling(data) {
  $('#job-scheduler-modal').modal('show');

  if (document.getElementById(
    'react-component-g4-logistics-portal-job-scheduler')) {
      ReactDOM.unmountComponentAtNode(
        document.getElementById(
          'react-component-g4-logistics-portal-job-scheduler'
        )
      );
    ReactDOM.render(
      <PortalJobScheduler
        jobId={data.id}
        data={data}
        isLoading={false}
      />,
      document.getElementById(
        'react-component-g4-logistics-portal-job-scheduler'
      ));
  }
}

const JobDropoffLocation = ({ text, data }) => (
  <div id={data.id+'-dropoff'}
  style={{
    position: 'relative', color: data.dropoff_text_colour,
    background: data.dropoff_colour, textAlign: 'center',
    height: 16, width: 16, borderRadius: '0', content: "D",
    lineHeight: "16px"
  }}
  onMouseOut={() => {
    $('.dashboard-map-marker').fadeIn();
    $('.dashboard-map-driver-marker').fadeIn();
  }}
  className="dashboard-map-dropoff-location dashboard-map-marker"
  >
  <div onClick={(e) => {
    $('#'+data.id+'-dropoff .dashboard-map-popup').slideDown();
  }}>D</div>

  <div className="dashboard-map-popup">
  <button onClick={(e) => {

    $('#'+data.id+'-dropoff .dashboard-map-popup').fadeOut();
  }} className="dashboard-map-popup-close-button btn btn-sm btn-dark"> X </button>

  <h4>
  Dropoff Point for <a href={"/jobs/view/"+data.id}
                       className="btn btn-primary btn-sm">
                       Job #{data.id}</a>
  </h4>

  <div className="text-left">
  <strong>Company:</strong> {data.company.name}<br />
  <strong>Customer:</strong> {data.customer.name}<br />
  </div>
  <br />

  <div className="text-left">
  <div className="row">
  <div className="col-md-5">
  {(data.driver_id != null) ?
    <p>
    <strong>Driver:</strong><br />
    <a href={"/drivers/view/"+data.driver.id}>
    {data.driver.user.first_name} {data.driver.user.last_name}
    <img src={"/user-images/"+data.driver.user.id}
         height="100" width="100" />
    </a>
    </p>

    : <p className="alert alert-danger alert-in-map"
    onClick={(e) => handleJobScheduling(data)}>
    <i className="fa fa-exclamation"></i> No Driver.<br />
    <i className="fa fa-exclamation"></i> Not Scheduled.</p>
  }
  </div>
  <div className="col-md-7">
  <strong>Scheduled for Pickup:</strong><br />
  {data.pickup_preposition}&nbsp;&nbsp;
  {data.pickup_day} / {data.pickup_month} / {data.pickup_year}<br />
  @ {data.pickup_time}<br />
  <br />
  <strong>Scheduled for Dropoff:</strong><br />
  {data.dropoff_preposition}&nbsp;&nbsp;
  {data.dropoff_day} / {data.dropoff_month} / {data.dropoff_year}<br />
  @ {data.dropoff_time}<br />
  <br />
  <strong>Vehicle:</strong><br />
  {data?.vehicle?.type}<br />
  {data?.vehicle?.colour} {data?.vehicle?.make} {data?.vehicle?.model}<br />
  <em>reg:</em> {data?.vehicle?.registration_number}
  </div>
  </div>
  </div>


  <div className="text-left">
  <strong>Pickup Address:</strong>
  <p>
  {data.pickup_address.house_number_or_name}&nbsp;
  {data.pickup_address.address_line_1}&nbsp;
  {data.pickup_address.address_line_2}&nbsp;
  {data.pickup_address.address_line_3}&nbsp;
  {data.pickup_address.town_city}&nbsp;
  {data.pickup_address.county_area}&nbsp;
  {data.pickup_address.country}<br />
  {data.pickup_address.postcode}
  </p>
  <strong>Dropoff Address:</strong>
  <p>
  {data.dropoff_address.house_number_or_name}&nbsp;
  {data.dropoff_address.address_line_1}&nbsp;
  {data.dropoff_address.address_line_2}&nbsp;
  {data.dropoff_address.address_line_3}&nbsp;
  {data.dropoff_address.town_city}&nbsp;
  {data.dropoff_address.county_area}&nbsp;
  {data.dropoff_address.country}<br />
  {data.dropoff_address.postcode}
  </p>
  </div>
  </div>
  </div>
);



class G4LogisticsPortalDashboardMap extends Component {
  static googleMap;
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      companies: props.companiesAll || [],
      selectedCustomerId: null,
      visible: false,
      center: {lat: 53.0236, lng: -2.211},
      zoom: 7,
      jobs: props.jobsAllNonComplete || [],
      driversWithLastKnownLocation: [],
      toggleOptionsJustPickups: false,
      toggleOptionsJustDropoffs: false,
      toggleOptionsJustDrivers: false,
      play: false,
      bootstrapURLKeys: { key: process.env.MIX_GOOGLE_API_KEY },
    };
    Echo.channel('users-table')
    .listen('UserAccountLocked',
      (e) => {
        this.getJobs();
        this.getDriversWithLastKnownLocation();
      }
    );
    Echo.channel('users-table')
    .listen('UserAccountUnlocked',
      (e) => {
        this.getJobs();
        this.getDriversWithLastKnownLocation();
      }
    );
    Echo.channel('jobs-table').
    listen('NewJob',
      (e) => {
        this.getJobs();
      }
    );
    Echo.channel('job-planner').
    listen('JobPlannerChanged',
      (e) => {
        this.getJobs();
      }
    );
    Echo.channel('drivers-movements').
      listen('DriverMoved',
      (e) => {
        this.getDriversWithLastKnownLocation();
      }
    );
    this.getJobs();
    this.getDriversWithLastKnownLocation();
  }

  componentDidMount() {
    this.setState({
      play: true
    });
  }

  getDriversWithLastKnownLocation() {
    let url = "/api/v1/portal/drivers/locations/last-known/for-current-user-company";
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token,
        "Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((response) => {
        this.setState({
          driversWithLastKnownLocation: response,
          isLoading: false
        })
      });
    });
  }

  getJobs() {
    let url = "/api/v1/portal/jobs/for-dashboard-map";
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token,
        "Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((response) => {
        this.setState({
          jobs: response,
          isLoading: false
        })
      });
    });
  }
  handleToggle(e, toggleType) {
    let button;
    let currentToggleState;
    switch (toggleType) {
      case 'just_drivers':
        currentToggleState = !this.state.toggleOptionsJustDrivers;
        if ((currentToggleState === true) &&
          this.state.toggleOptionsJustDropoffs === true) {
          return false;
        }
        if ((currentToggleState === true) &&
          this.state.toggleOptionsJustPickups === true) {
          return false;
        }
        button = document.querySelector('#toggle_just_drivers i');
        button.classList.toggle('fa-toggle-on');
        button.classList.toggle('fa-toggle-off');
        if (currentToggleState === true) {
          $('.dashboard-map-dropoff-location').hide();
          $('.dashboard-map-driver-marker').show();
          $('.dashboard-map-pickup-location').hide();
        }
        else {
          $('.dashboard-map-dropoff-location').show();
          $('.dashboard-map-driver-marker').show();
          $('.dashboard-map-pickup-location').show();
        }
        this.setState({
          toggleOptionsJustDrivers: !this.state.toggleOptionsJustDrivers
        });
        break;
      case 'just_pickups':
        currentToggleState = !this.state.toggleOptionsJustPickups;
        if ((currentToggleState === true) &&
        this.state.toggleOptionsJustDropoffs === true) {
          return false;
        }
        if ((currentToggleState === true) &&
          this.state.toggleOptionsJustDrivers === true) {
          return false;
        }
        button = document.querySelector('#toggle_just_pickups i');
        button.classList.toggle('fa-toggle-on');
        button.classList.toggle('fa-toggle-off');
        if (currentToggleState === true) {
          $('.dashboard-map-dropoff-location').hide();
          $('.dashboard-map-driver-marker').hide();
          $('.dashboard-map-pickup-location').show();
        }
        else {
          $('.dashboard-map-dropoff-location').show();
          $('.dashboard-map-driver-marker').show();
          $('.dashboard-map-pickup-location').show();
        }
        this.setState({
          toggleOptionsJustPickups: !this.state.toggleOptionsJustPickups
        });
      break;
      case 'just_dropoffs':
        currentToggleState = !this.state.toggleOptionsJustDropoffs;
        if ((currentToggleState === true) &&
          this.state.toggleOptionsJustPickups === true) {
          return false;
        }
        if ((currentToggleState === true) &&
          this.state.toggleOptionsJustDrivers === true) {
          return false;
        }
        button = document.querySelector('#toggle_just_dropoffs i');
        button.classList.toggle('fa-toggle-on');
        button.classList.toggle('fa-toggle-off');
        if (currentToggleState === true) {
          $('.dashboard-map-pickup-location').hide();
          $('.dashboard-map-driver-marker').hide();
          $('.dashboard-map-dropoff-location').show();
        }
        else {
          $('.dashboard-map-dropoff-location').show();
          $('.dashboard-map-driver-marker').show();
          $('.dashboard-map-pickup-location').show();
        }
        this.setState({
          toggleOptionsJustDropoffs: !this.state.toggleOptionsJustDropoffs
        });
        break;
    }
  }
  render() {
    let Jobs = [];
    let Drivers = [];
    let BoxJobs = [];
    let BoxDrivers = [];
    let pickupColour = '#0f0';
    let pickupTextColour = '#000';
    let dropoffColour = '#f00';
    let dropoffTextColour = '#fff';
    let thisDriverMarkersLat = 0;
    let thisDriverMarkersLng = 0;

    this.state.jobs.forEach(function(i) {
      pickupColour = 'green';
      pickupTextColour = '#fff';
      dropoffColour = 'red';
      dropoffTextColour = '#fff';

      if (i.driver_id == null) {
        pickupColour = '#000';
        dropoffColour = '#000';
        pickupTextColour = 'yellow';
        dropoffTextColour = 'yellow';
      }

      i.pickup_colour = pickupColour;
      i.pickup_text_colour = pickupTextColour;
      i.dropoff_colour = dropoffColour;
      i.dropoff_text_colour = dropoffTextColour;
      Jobs.push(<JobPickupLocation key={'job-'+i.id+'-pickup-location'}
                                   data={i}
                                   lat={i.pickup_address.latt}
                                   lng={i.pickup_address.long} />);
      Jobs.push(<JobDropoffLocation key={'job-'+i.id+'-dropoff-location'}
                                    data={i}
                                    lat={i.dropoff_address.latt}
                                    lng={i.dropoff_address.long} />);

      BoxJobs.push(<BoxJob key={'box-job-'+i.id} data={i} />);

    });

    if (this.state.driversWithLastKnownLocation.length > 0) {
      this.state.driversWithLastKnownLocation.forEach(function (user) {
        thisDriverMarkersLat = user.driver.home_address.latt;
        thisDriverMarkersLng = user.driver.home_address.long;

        if (user.driver.geolocations.length === 1) {
          thisDriverMarkersLat = user.driver.geolocations[0].latt;
          thisDriverMarkersLng = user.driver.geolocations[0].long;
        }
        Drivers.push(
          <DriverMarker key={'driver-' + user.driver.id + '-marker'}
                        data={user}
                        lat={thisDriverMarkersLat}
                        lng={thisDriverMarkersLng}
          />
        );
        BoxDrivers.push(
          <BoxDriver key={'box-driver-' + user.driver.id} data={user}/>
        );
      });
    }
    return (
      <div id="g4-logistics-portal-google-map-react-container">
        <div id="dashboard-map-toggle-options">
          <Animate
            play={this.state.play}
            start={{opacity: 0}}
            end={{opacity: 1}}
          >
            <button
              id="toggle_just_drivers"
              className="btn btn-sm btn-light"
              onClick={(e) => {
              this.handleToggle(
                e, 'just_drivers')
            }}>
              <i className="fa fa-toggle-off"></i>&nbsp;
              Just Drivers
            </button>&nbsp;
            <button
              id="toggle_just_pickups"
              className="btn btn-sm btn-light"
              onClick={(e) => {
              this.handleToggle(
                e, 'just_pickups')
            }}>
              <i className="fa fa-toggle-off"></i>&nbsp;
              Just Pickups
            </button>&nbsp;
            <button
              id="toggle_just_dropoffs"
              className="btn btn-sm btn-light"
              onClick={(e) => {
              this.handleToggle(
                e, 'just_dropoffs')
            }}>
              <i className="fa fa-toggle-off"></i>&nbsp;
              Just Dropoffs
            </button>
          </Animate>
        </div>
        <div id="box-jobs">
        <Animate
          play={this.state.play}
          start={{opacity: 0}}
          end={{opacity: 1}}
        >
          {BoxJobs}
        </Animate>
        </div>
        <div id="box-drivers">
        <Animate
          play={this.state.play}
          start={{opacity: 0}}
          end={{opacity: 1}}
        >
          {BoxDrivers}
        </Animate>
        </div>
        <GoogleMapReact
        bootstrapURLKeys={this.state.bootstrapURLKeys}
        defaultCenter={this.state.center}
        defaultZoom={this.state.zoom}
        yesIWantToUseGoogleMapApiInternals
        >
          {Jobs}
          {Drivers}
        </GoogleMapReact>
      </div>
    );
  }
}

if (document.getElementById(
  'react-component-g4-logistics-portal-dashboard'
)) {
  ReactDOM.render(<G4LogisticsPortalDashboardMap />,
    document.getElementById(
      'react-component-g4-logistics-portal-dashboard'
    )
  );
}
